import { Radio, Table, message, Empty } from '@drip/drip-design';
import React, { useEffect, useState } from 'react';
import { getMemberList, deleteMemberList } from '@/components/SpacialListConfig/apis';
import Delete from '@/components/delete';
import ComponentLog from '@/components/component-log';

export default function DistributeList(props) {
  const { id, needFresh, isPartner } = props;
  const [conditions, setConditions] = useState({ whiteId: id, allocationType: '1', currentPage: 1, pageSize: 10 });
  const [data, setDate] = useState({
    list: [],
    totalCount: 0,
  });

  useEffect(() => {
    if (!needFresh) return;
    let didMount = true;
    getMemberList(conditions)
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '权限分配列表请求失败';
        setDate(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
    return () => {
      didMount = false;
    };
  }, [conditions, needFresh]);

  const deleteMember = (id) => {
    deleteMemberList({ id })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0' || !data) throw msg || '权限删除失败';
        setConditions({ ...conditions });
        message.success('删除成功');
      })
      .catch((ex) => {
        message.error(ex);
      });
  };

  const options = [
    { label: '分配erp', value: '1' },
    { label: '分配部门', value: '2' },
    { label: '分配全部erp', value: '3', hidden: isPartner },
  ].filter((ele) => !ele.hidden);

  const columns = [
    {
      title: '分配对象',
      width: '500px',
      render(record) {
        const { erp, organizationName } = record;
        if (conditions.allocationType === '1') return erp;
        if (conditions.allocationType === '2') return organizationName;
        return 'erp全员';
      },
    },
    {
      title: '权限类型',
      width: '160px',
      dataIndex: 'identityType',
      render(identityType) {
        return identityType == 3 ? '协作者' : '申请者';
      },
    },
    {
      title: '操作',
      fixed: 'right',
      render(record) {
        return (
          <Delete onConfirm={() => deleteMember(record.id)}>
            <ComponentLog clstag="yx_whiteapply_page_1706591686206|10">
              <a>删除</a>
            </ComponentLog>
          </Delete>
        );
      },
    },
  ];
  return (
    <>
      <Radio.Group
        optionType="button"
        value={conditions.allocationType}
        options={options}
        onChange={(e) => setConditions({ ...conditions, allocationType: e.target.value, currentPage: 1 })}
      />
      <Table
        scroll={{ x: 'max-content' }}
        bordered
        columns={columns}
        dataSource={data.list}
        pagination={{
          hideOnSinglePage: true,
          current: conditions.currentPage,
          total: data.totalCount,
          pageSize: conditions.pageSize,
          onChange(page) {
            setConditions({ ...conditions, currentPage: page });
          },
        }}
        locale={{
          emptyText: <Empty image={null} style={{ color: 'rgba(0,0,0,0.82)' }} />,
        }}
      />
    </>
  );
}
